export function upHighlighted({ properties, property }) {
  const highlighted = properties.find(p => p.id === property?.id)

  return highlighted
    ? [{ ...highlighted, highlighted: true }, ...properties.filter(p => p.id !== property.id)]
    : properties
}
